import React from 'react';
import PropTypes from 'prop-types';

import CoachSelect from '../../../../components/Leads/components/CoachSelect';

import {
  SelectorRow,
  SelectorField,
  FieldLabel,
  DirectionIcon,
  Warning,
} from './styles';
import texts from './texts.json';

const CoachPairSelector = ({
  sourceCoach,
  targetCoach,
  onSourceChange,
  onTargetChange,
  disabled,
}) => {
  const isSameCoach = !!sourceCoach?.id && sourceCoach.id === targetCoach?.id;

  return (
    <>
      <SelectorRow>
        <SelectorField>
          <FieldLabel>{texts.sourceLabel}</FieldLabel>
          <CoachSelect
            id="migration-source-coach-select"
            onChange={onSourceChange}
            hideLabel
            /*
              A source/target pick must not move the dashboard's own coach context, which is
              what loadNewCoachData does when this defaults to true.
            */
            loadNewCoachDataOnChange={false}
            disabled={disabled}
          />
        </SelectorField>
        <DirectionIcon />
        <SelectorField>
          <FieldLabel>{texts.targetLabel}</FieldLabel>
          <CoachSelect
            id="migration-target-coach-select"
            onChange={onTargetChange}
            hideLabel
            loadNewCoachDataOnChange={false}
            disabled={disabled}
          />
        </SelectorField>
      </SelectorRow>
      {isSameCoach && <Warning>{texts.sameCoachWarning}</Warning>}
    </>
  );
};

CoachPairSelector.propTypes = {
  sourceCoach: PropTypes.object,
  targetCoach: PropTypes.object,
  onSourceChange: PropTypes.func.isRequired,
  onTargetChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CoachPairSelector.defaultProps = {
  sourceCoach: null,
  targetCoach: null,
  disabled: false,
};

export default CoachPairSelector;
